import classnames from 'classnames';

import style from './PatientAppIndicator.module.scss';

import { translate } from '@chaika/i18n/helper';
import { Icon, IconType } from '@components/Icon';
import { isDefined } from '@utils/isDefined';

import Check from './check.svg';
import { usePatientAppLink } from './hooks/usePatientAppLink';

interface Props {
    patientId: string;
    hideLabel?: boolean;
}

export function PatientAppIndicator({ patientId, hideLabel }: Props) {
    const { hasApp, isLinkSent, sendAppLink } = usePatientAppLink({ patientId });

    if (!isDefined(hasApp)) {
        return null;
    }

    if (hasApp) {
        return (
            <div
                className={classnames([style.status, style.statusInstalled])}
                title={translate('app')}
            >
                <Check />
                {!hideLabel && translate('app')}
            </div>
        );
    }

    if (isLinkSent) {
        return (
            <div
                className={classnames([style.status, style.statusLinkSent, style.withLegacyIcon])}
                title={translate('linkSentBySms')}
            >
                <Icon type={IconType.APP}></Icon>
                {!hideLabel && translate('linkSentBySms')}
            </div>
        );
    }

    return (
        <button
            type="button"
            className={classnames([style.buttonReset, style.status, style.sendLinkButton, style.withLegacyIcon])}
            title={translate('appSendLink')}
            onClick={sendAppLink}
        >
            <Icon type={IconType.APP} />
            {!hideLabel && translate('appSendLink')}
        </button>
    );
}
